<dc-page-header-wave
  [title]="'Elija su plan'"
  [subtitle]="'Elija el plan que más se adapte a su compañía.'"
>
</dc-page-header-wave>

<dc-pricing-plan></dc-pricing-plan>
<dc-cta1 [background]="'light'"></dc-cta1>
<!-- <dc-pricing-include></dc-pricing-include> -->
<dc-faqs1
  [edge]="'bottom-right'"
  [background]="'light'"
  [classes]="'border-top'"
></dc-faqs1>
<dc-start-now-box></dc-start-now-box>

<dc-footer1></dc-footer1>
